// dependencies.
import { curry, toString, get, isEmpty } from 'lodash'

const bypassHeader = url => url.indexOf('v1/auth/login') !== -1 || url.indexOf('v1/auth/refresh') !== -1
const bypassSetup = url => url.indexOf('v1/auth/user') !== -1
const getToken = store => get(store, 'getters.jwtToken', null)
const apiN1token = localStorage.getItem('n-token')

const getHeader = (request, store) => {
  const token = getToken(store)
  // token no padrão api-n1
  return isEmpty(token) ? null : {'token': apiN1token}
}
/**
 * Authorization / Token interceptor.
 */
export default curry((store, router, request) => {
  // request url string passado
  const url = toString(request.url)

  // should a authorization header be used?
  if (bypassHeader(url)) {
    return request
  }

  // is a setup needed?
  if (bypassSetup(url)) {
    request.headers = getHeader(request, store)
    return request
  }
  // dispatch the JWT setup action
  return store.dispatch('setupJWT').then(() => {
    // modificado para atender a api-n1
    request.headers = getHeader(request, store)
    return request
  }).catch(() => {
    return request
  })
})



// WEBPACK FOOTER //
// ./src/plugins/http/interceptors-n1/token.js